import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowTopBottom = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.04144 2.24023L10.2587 6.45745L9.37477 7.34134L6.66644 4.633V17.4991H5.41644V4.633L2.7081 7.34134L1.82422 6.45745L6.04144 2.24023ZM14.5831 2.49912V15.3652L17.2914 12.6569L18.1753 13.5408L13.9581 17.758L9.74089 13.5408L10.6248 12.6569L13.3331 15.3652V2.49912H14.5831Z",
		fill: "currentColor"
	})]
});
export default SvgArrowTopBottom;
